import React from "react";
import { Link } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import { Typewriter } from "react-simple-typewriter";

function Hero() {

  return (
    <>
      <section className="relative bg-[url('hero-bg.jpg')] bg-cover bg-center h-[60vh] text-white">
        <div className="absolute inset-0 bg-black bg-opacity-50" />

        <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4 max-w-2xl mx-auto">
          {/* 메인 타이틀 */}
          {/* h1 타이핑 */}
          <h1 className="text-3xl md:text-5xl font-bold leading-tight mb-6">
            <Typewriter
              words={['스마트 공조의 미래, JDWinTech이 이끕니다.']}
              loop={1}
              cursor
              cursorStyle="|"
              typeSpeed={60}
              deleteSpeed={0}
              delaySpeed={1000}
            />
          </h1>

          {/* p 타이핑 - key 부여로 리렌더 강제 */}
          <p className="text-lg md:text-xl mb-8">
            <Typewriter
              key="subtitle-start"
              words={[
                '첨단 기술로 완성된 배연창 · 스마트 HVAC 시스템, 이제 선택이 아닌 필수입니다.'
              ]}
              loop={1}
              cursor={false}
              typeSpeed={40}
              deleteSpeed={0}
              delaySpeed={300}
            />
          </p>

          <Link
            to="/products"
            className="inline-block px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg transition mb-6"
          >
            제품소개 바로가기
          </Link>

          <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2">
            <ChevronDown size={36} className="animate-bounce text-white opacity-80" />
          </div>
        </div>
      </section>

      {/* 설명 콘텐츠 */}
      <section className="bg-white py-20 px-6 md:px-10 text-center">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">
            JDWinTech 스마트 HVAC & 배연창 솔루션
          </h2>
          <p className="text-base md:text-lg text-gray-600 leading-relaxed mb-8">
            JDWinTech은 고객 중심의 배연 시스템과 스마트 공조 기술을 융합하여
            화재 시 연기 배출 자동화, 실시간 제어, 에너지 최적화 기술을 제공하며
            고객의 설비 운영을 더욱 안전하고 효율적으로 변화시킵니다.
          </p>
          <Link
            to="/contact"
            className="inline-block px-6 py-3 bg-red-600 hover:bg-red-700 text-white font-semibold rounded-full transition"
          >
            솔루션문의
          </Link>
        </div>
      </section>
      <section className="bg-white px-6 md:px-10 py-20">
        {/* 제품 솔루션 */}
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-20 items-center">
          <img src="/product-intro.jpg" alt="제품 소개" className="rounded-xl shadow-md" />
          <div>
            <h3 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">제품 솔루션</h3>
            <p className="text-red-600 font-semibold text-2xl mb-4 leading-snug">
              “연기보다 빠르게 반응하는 스마트 배연창 시스템”
            </p>
            <ul className="text-gray-600 font-medium leading-relaxed text-sm md:text-base list-disc pl-5 mb-6 space-y-2">
              <li>화재 발생 시 연기를 자동 감지하고 신속하게 작동하여 대피 환경을 조성합니다.</li>
              <li>건물 구조에 맞춘 커스터마이징 설계로 다양한 환경에 적용 가능합니다.</li>
              <li>IoT 제어 연동으로 실시간 상태 모니터링 및 자동 개폐 제어를 지원합니다.</li>
              <li>안전성과 에너지 효율을 모두 충족하는 고성능 솔루션입니다.</li>
            </ul>
            <button className="px-6 py-3 bg-red-600 hover:bg-red-700 text-white rounded-full font-semibold transition">
              제품 자세히보기
            </button>
          </div>
        </div>

        {/* 스마트 공조 시스템 */}
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-20 items-center">
          <div>
            <h3 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">스마트 공조 시스템</h3>
            <p className="text-red-600 font-semibold text-2xl mb-4 leading-snug">
              “에너지 절감과 쾌적함을 동시에 구현하는 스마트 HVAC”
            </p>
            <ul className="text-gray-600 font-medium leading-relaxed text-sm md:text-base list-disc pl-5 mb-6 space-y-2">
              <li>실내 온도, 습도, CO₂ 농도 등 환경 데이터를 실시간 분석합니다.</li>
              <li>자동 공조 제어로 최적의 쾌적함과 에너지 효율을 동시에 실현합니다.</li>
              <li>IoT 기반 원격 제어 시스템으로 관리자 편의성이 향상됩니다.</li>
              <li>친환경성과 사용자 중심 편의성을 모두 갖춘 미래형 솔루션입니다.</li>
            </ul>
            <button className="px-6 py-3 bg-red-600 hover:bg-red-700 text-white rounded-full font-semibold transition">
              솔루션 자세히보기
            </button>
          </div>
          <img src="/solution-intro.jpg" alt="스마트 공조 시스템" className="rounded-xl shadow-md" />
        </div>
      </section>
    </>
  );
}

export default Hero;